/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Option/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaButtonWithText from 'DesignSystem/TysiaButtonWithText/index'



/** @type {import('Simple/types.js').View} */
export default function Option({
  children,
  viewPath = "/DesignSystem/ImageCard/Content/Content/Actions/Options/Option"
  
}) {
let optionTextValueData = fromData.useDataValue({ viewPath,
context: 'option',
path: 'text',
})
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<TysiaButtonWithText
  viewPath={`${viewPath}/TysiaButtonWithText`}
 type="ghost"
 onClick={onClick}
 width="100%"
 data="option.text"
 text={optionTextValueData}
/>
{children}
</React.Fragment>)
}